(function(){
  const root=document.querySelector('[data-bmc]'); if(!root) return;
  const form=root.querySelector('[data-bmc-form]');
  const params=()=>{const fd=new FormData(form);const u=new URLSearchParams();for(const [k,v] of fd.entries()){if(v!=='')u.append(k,v)}return u};
  const go=()=>{window.location.search=params().toString()};
  root.addEventListener('change',e=>{
    if(e.target.matches('[data-bmc-auto]')){ if(window.matchMedia('(min-width: 990px)').matches) go(); }
    if(e.target.matches('[data-bmc-sort]')){const u=new URLSearchParams(window.location.search);u.set('sort_by',e.target.value);u.delete('page');window.location.search=u.toString()}
  });
  form&&form.addEventListener('submit',e=>{e.preventDefault();go()});
  const side=root.querySelector('.bmc-side');
  root.querySelectorAll('[data-bmc-open]').forEach(b=>b.addEventListener('click',()=>{side.classList.add('is-open');document.body.style.overflow='hidden';const c=side.querySelector('[data-bmc-close]');c&&c.focus()}));
  const close=()=>{side.classList.remove('is-open');document.body.style.overflow=''};
  root.querySelectorAll('[data-bmc-close]').forEach(b=>b.addEventListener('click',close));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&side.classList.contains('is-open'))close()});
  side&&side.addEventListener('click',e=>{if(e.target===side&&side.classList.contains('is-open'))close()});
  // show more
  root.addEventListener('click',async e=>{
    const more=e.target.closest('[data-bmc-more]'); if(!more) return;
    e.preventDefault(); more.setAttribute('aria-busy','true'); more.textContent='Loading…';
    try{
      const html=await (await fetch(more.href)).text();
      const doc=new DOMParser().parseFromString(html,'text/html');
      const grid=root.querySelector('[data-bmc-grid]');
      doc.querySelectorAll('[data-bmc-grid] > .bmc-grid__item').forEach(li=>grid.appendChild(document.adoptNode(li)));
      const next=doc.querySelector('.bmc-more'); const cur=root.querySelector('.bmc-more');
      if(next){cur.replaceWith(document.adoptNode(next))}else{cur.remove()}
      history.replaceState(null,'',more.href);
    }catch(err){window.location=more.href}
  });
  // quick add
  const toast=root.querySelector('[data-bmc-toast]');let tt;
  const say=m=>{toast.textContent=m;toast.classList.add('is-on');clearTimeout(tt);tt=setTimeout(()=>toast.classList.remove('is-on'),2600)};
  root.addEventListener('click',async e=>{
    const b=e.target.closest('[data-bmc-add]'); if(!b) return;
    b.setAttribute('aria-busy','true');
    try{
      const r=await fetch((window.routes&&window.routes.cart_add_url?window.routes.cart_add_url:'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(b.dataset.bmcAdd),quantity:1}]})});
      const j=await r.json();
      if(!r.ok||j.status){say(j.description||j.message||'Could not add to cart');return}
      b.classList.add('is-done');b.textContent='✓';setTimeout(()=>{b.classList.remove('is-done');b.textContent='+'},1800);
      const drawer=document.querySelector('cart-drawer');
      if(drawer&&typeof drawer.reload==='function'){drawer.reload();setTimeout(()=>{drawer.classList.remove('is-empty');!(window.bmApp&&window.bmApp.mobile())&&drawer.open&&drawer.open(b)},350)}
      else{say((window.bmT&&bmT.added)||'Added to cart')}
    }catch(err){say((window.bmT&&bmT.fail)||'Could not add to cart')}
    finally{b.removeAttribute('aria-busy')}
  });
})();
